import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Additionalflat } from './additionalflat.model';
import { AdditionalflatService } from './additionalflat.service';

@Component({
    selector: 'jhi-additionalflat-detail',
    templateUrl: './additionalflat-detail.component.html'
})
export class AdditionalflatDetailComponent implements OnInit, OnDestroy {

    additionalflat: Additionalflat;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private additionalflatService: AdditionalflatService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['additionalflat']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInAdditionalflats();
    }

    load(id) {
        this.additionalflatService.find(id).subscribe((additionalflat) => {
            this.additionalflat = additionalflat;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInAdditionalflats() {
        this.eventSubscriber = this.eventManager.subscribe('additionalflatListModification', (response) => this.load(this.additionalflat.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat-detail.component.ts